module.exports = __webpack_public_path__ + "img/title_1.fa29b678.png";